// Modal Custom Element
class ModalCustom extends HTMLElement {
  /** @type {HTMLButtonElement} */
  get trigger() {
    const trigger = this.querySelector('[data-modal-trigger]');

    if (!(trigger instanceof HTMLButtonElement)) throw new Error('Trigger button not found');

    return trigger;
  }

  /** @type {HTMLDialogElement} */
  get dialog() {
    const dialog = this.querySelector('[data-modal-dialog]');

    if (!(dialog instanceof HTMLDialogElement)) throw new Error('Dialog element not found');

    return dialog;
  }

  /** @type {HTMLElement} */
  get closeButton() {
    const closeButton = this.querySelector('[data-modal-close]');

    if (!(closeButton instanceof HTMLElement)) throw new Error('Close button not found');

    return closeButton;
  }

  /** @type {HTMLElement} */
  get overlay() {
    const overlay = this.querySelector('[data-modal-overlay]');

    if (!(overlay instanceof HTMLElement)) throw new Error('Overlay not found');

    return overlay;
  }

  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this.trigger.addEventListener('click', this.handleOpen, { signal });
    this.closeButton.addEventListener('click', this.handleClose, { signal });
    this.overlay.addEventListener('click', this.handleClose, { signal });
    this.dialog.addEventListener('keydown', this.#handleKeyDown, { signal });
  }

  /**
   * Handles the disconnect event.
   */
  disconnectedCallback() {
    // Disconnect all the event listeners
    this.#controller.abort();
  }

  /**
   * Handles opening the modal
   * @param {Event} event - The event.
   */
  handleOpen = (event) => {
    event.preventDefault();
    this.dialog.showModal();

    // Prevent body scroll on mobile
    document.body.style.overflow = 'hidden';
  };

  /**
   * Handles closing the modal
   * @param {Event} event - The event.
   */
  handleClose = (event) => {
    event.preventDefault();
    this.dialog.close();

    // Re-enable body scroll
    document.body.style.overflow = '';
  };

  /**
   * Handles keydown events for the modal
   * @param {KeyboardEvent} event - The keyboard event.
   */
  #handleKeyDown = (event) => {
    // Close modal on Escape key
    if (event.key === 'Escape') {
      this.handleClose(event);
    }
  };
}

if (!customElements.get('modal-custom')) {
  customElements.define('modal-custom', ModalCustom);
}
